import { root } from './exdate';

export const exdate = {
  ...root,
};
